import React from 'react';
import { Outlet } from 'react-router-dom';
import ModulePageLayout from './ModulePageLayout';

/**
 * Layout partagé pour tout le parcours en formation : chapitres (capsule, quiz, …)
 * et questionnaires diagnostic / impact. Évite de démonter la timeline à gauche
 * lors des navigations entre ces vues.
 */
const LearningLayout: React.FC = () => (
  <ModulePageLayout>
    <Outlet />
  </ModulePageLayout>
);

export default LearningLayout;
